import { Component, OnInit } from '@angular/core';
import { ChartType, ChartOptions, ChartDataset } from 'chart.js';

@Component({
    selector: 'pie-chart',
    templateUrl: './pie-chart.component.html',
    styleUrls: ['./pie-chart.component.css'],
    standalone: false
})
export class PieChartComponent implements OnInit {

  public pieChartOptions: ChartOptions = {
    responsive: true,
  };
  public pieChartLabels: string[] = ['SciFi', 'Drama', 'Comedy'];
  public pieChartData: ChartDataset[] = [{ data: [30, 50, 20] }];
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartPlugins = [];

  constructor() { }

  ngOnInit() {
  }

}
